<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人脸检测</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对图片的BGR24倒立数据进行人脸检测与分析，该接口与视频人脸检测与跟踪接口存在互斥，不可并行调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (void)skFaceImageDetect:(unsigned char *)pBGR24
                    width:(int)width
                   height:(int)height
                    model:(int)model
          attributesModel:(BOOL)attributesModel
             featureModel:(BOOL)featureModel
            keyPointModel:(BOOL)keyPointModel
       faceDetectCallback:(void (^)(struct FaceStruct* faceStruct, int retCount))faceDetectCallback;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pBGR24：图片的bgr数据（BGR倒立数据）</p>
        <p class="doc_main_p">（2）width：图片宽度</p>
        <p class="doc_main_p">（3）height：图片高度</p>
        <p class="doc_main_p">
        	（4）model：表示检测模式，0：默认人脸检测，1：快速人脸检测，2：大头照人脸检测（建议使用1快速人脸检测）
        </p>
        <p class="doc_main_p">
        	（5）attributesModel：是否需要属性信息（性别[0 不清楚 1 女性 2 男性]、年龄[<=0 表示不清楚]、是否戴眼镜[0 不戴眼镜 1 戴眼镜 2 太阳镜 <0 表示不清楚]）
        </p>
        <p class="doc_main_p">
        	（6）featureModel    是否需要特征值
        </p>
        <p class="doc_main_p">
        	（7）keyPointModel：是否需要关键点信息（人脸形状72个关键点信息，先x后y【企业提供】）
        </p>
        <p class="doc_main_p">
        	（8）faceDetectCallback(FaceStruct * FaceStruct, int retCount): 人脸检测结果回调
FaceStruct检测结果结构体数组，retCount人脸个数

        </p>
        <h3 class="doc_main_h3">返回值</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 检测结果结构体
struct CFaceStruct
{
   int nFaceRX1;                     // 人脸矩形左上点X
   int nFaceRY1;                     // 人脸矩形左上点Y
   int nFaceRX2;                     // 人脸矩形右上点X
   int nFaceRY2;                     // 人脸矩形右上点Y
   int nFaceRX3;                     // 人脸矩形右下点X
   int nFaceRY3;                     // 人脸矩形右下点Y
   int nFaceRX4;                     // 人脸矩形左下点X
   int nFaceRY4;                     // 人脸矩形左下点Y
   int nFaceRectSX;                // 人脸正方形起始点X
   int nFaceRectSY;                // 人脸正方形起始点Y
   int nFaceSize;                     // 人脸正方形边长
   int nTrackID;                         // 人脸追踪ID(随机值，主要用于跟踪标记)
   float fImageQuality;              // 人脸图像品质(0.0 - 1.0),大于0.7则表示人脸特征有效
   int nUpdate;                         // 人脸图像可识别更新情况,主要用于人脸跟踪.0:不建议更新,1:建议更新
   int nPitch;                            // 抬头低头欧拉角[-90,-90],在[-30,30]范围内进行人脸特征提取有效
   int nRoll;                             // 人脸面内旋转欧拉角[-180,180],360全角度进行人脸特征提取有效
   int nYaw;                            // 左右转动欧拉角[-90,90],在[-45,45]范围内进行人脸特征提取有效
   int nFaceDistance;            // 人脸距离,小于0则表示无效(未检测到距离)
   char szPersonID[PERSON_ID_LEN];   // 人员ID
   char szName[PERSON_NAME_LEN];     // 人员姓名
   int nAge;                           // 年龄,小于0表示不清楚
   int nSex;                           // 性别,0:不清楚;1:女性;2:男性
   int nGlasses;                     // 是否带眼镜,小于0表示不清楚,0:不戴眼镜;1:戴眼镜;2:太阳镜;
   //char szFeature[PERSON_FEATURE_LEN + 1];       // 人脸特征值,经过Base64后的长度，已废弃
   unsigned char szBinFeature[PERSON_FEATURE_BIN_LEN]; // 人脸特征值，未经过base64加密
   float arrKeyPoint[144];        // 人脸关键点信息(共72个关键点，先X后Y),[企业版提供]
};
#endif</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">[SKFaceManagerInterface skFaceImageDetect:BGR24 width:1080 height:720 model:1 attributesModel:true 
      featureModel:true keyPointModel:true faceDetectCallback:
      ^(struct FaceStruct *faceStruct, int retCount) {
            //处理回调
}];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','图片接口','人脸检测'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/image/faceTesting.vue